import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import authEndpoints from './auth'
import serviceTypeEndpoints from './serviceTypes'
import customerEndpoints from './customers'
import expenseEndpoints from './expenses'
import employeeEndpoints from './employee'
import salaryEndpoints from './salaries'
import orderEndpoints from './orders'
import itemCategoryEndpoints from './itemCategories'
import subscriptionEndpoints from './subscriptions'
import tenantEndpoints from './tenants'
import appUserEndpoints from './appUsers'
import pricingSettingEndpoints from './pricingSettings'


const DcoreUrl = process.env.REACT_APP_API_URL 


const baseQuery = fetchBaseQuery({
  baseUrl: DcoreUrl,
  prepareHeaders: (headers, { endpoint }) => {
    const token = sessionStorage.getItem('authToken')
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    // For file upload endpoints, don't set Content-Type (let browser set it)
    // if (endpoint !== 'createEmployee' && endpoint !== 'updateEmployee') {
    //   headers.set('Content-Type', 'application/json');
    // }
    headers.set('accept', 'application/json')
    headers.set('lang', 'ENGLISH')
    return headers
  },
})


const baseQueryIntercep: typeof baseQuery = async (args, api, extraOptions) => {
  let queryResult = await baseQuery(args, api, extraOptions)
  return queryResult
}


const appApi = createApi({
  reducerPath: 'data',
  baseQuery: (args, api, extraOptions) => {
    return baseQueryIntercep(args, api, extraOptions);
  },
  tagTypes: [
    'customers',
    'expenses',
    'employees',
    'salaries',
    'orders',
    'itemCategories',
    'subscriptions',
    'tenants',
    'appUsers',
    'pricingSettings',
  ],
  endpoints: (builder) => ({
    ...authEndpoints(builder),
    ...serviceTypeEndpoints(builder),
    ...customerEndpoints(builder),
    ...expenseEndpoints(builder),
    ...employeeEndpoints(builder),
    ...salaryEndpoints(builder),
    ...orderEndpoints(builder),
    ...itemCategoryEndpoints(builder),
    ...subscriptionEndpoints(builder),
    ...tenantEndpoints(builder),
    ...appUserEndpoints(builder),
    ...pricingSettingEndpoints(builder),
  }),
})

export default appApi

export const {
  useLoginMutation,

  useFetchServiceTypesQuery,
  useCreateServiceTypeMutation,

  useFetchCustomersQuery,
  useFetchCustomerByIdQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,

  useFetchExpensesQuery,
  useCreateExpenseMutation,
  useDeleteExpenseMutation,
  useUpdateExpenseMutation,
  useFetchExpenseReportQuery,

  useFetchEmployeesQuery,
  useFetchEmployeeByIdQuery,
  useCreateEmployeeMutation,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,

  useFetchSalariesQuery,
  useFetchSalaryByIdQuery,
  useCreateSalaryMutation,
  useUpdateSalaryMutation,
  useDeleteSalaryMutation,
  useFetchSalarySummaryQuery,

  useFetchOrdersQuery,
  useFetchOrderByIdQuery,
  useFetchOrdersSummaryQuery,
  useFetchOrderReportQuery,
  useFetchOrderCustomerReportQuery,
  useCreateOrderMutation,
  useUpdateOrderStatusMutation,
  useMakePaymentMutation,
  useAddOrderTransportMutation,
  useFetchOrderTransportQuery,
  useDeleteOrderMutation,
  useLazyFetchOrderSmsPreviewQuery,
  useSendOrderSmsMutation,

  useFetchItemCategoriesQuery,
  useFetchItemCategoriesListQuery,
  useCreateItemCategoryMutation,
  useUpdateItemCategoryMutation,
  useDeleteItemCategoryMutation,

  useFetchSubscriptionPackagesQuery,
  useFetchSubscriptionsQuery,
  useFetchSubscriptionByIdQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionMutation,
  useCancelSubscriptionMutation,
  useReactivateSubscriptionMutation,
  useDeleteSubscriptionMutation,
  useRestoreSubscriptionMutation,
  useRecordSubscriptionPaymentMutation,
  useFetchSubscriptionPaymentsQuery,
  useFetchSubscriptionReportQuery,
  useFetchSubscriptionOrdersQuery,

  useFetchTenantsQuery,
  useFetchTenantByIdQuery,
  useCreateTenantMutation,
  useSuspendTenantMutation,
  useReactivateTenantMutation,
  useDeleteTenantMutation,
  useFetchTenantUsersQuery,
  useCreateTenantUserMutation,

  useFetchAppUsersQuery,
  useCreateAppUserMutation,
  useToggleAppUserEnabledMutation,
  useResetAppUserPasswordMutation,
  useDeleteAppUserMutation,
  useFetchPricingSettingQuery,
  useUpdatePricingSettingMutation,
} = appApi
